import './tipsNewDialog.css'
const TipsNewDialog = {
  install: function (Vue) {
    Vue.prototype.$tipsNewDialog = function alert(
        title = "提示",
        msg = "是否删除",
        content = "是否删除当前项",
				tis = "提示信息",
        iconType = "el-icon-warning", //图标类型
        iconColor = "#ccc", //图标颜色
        settings = {}
    ) { 
      Object.assign(settings, {
        confirmButtonText: "确 定",
        cancelButtonText: "取 消",
        dangerouslyUseHTMLString: true,
        customClass: 'el_tips_new_dialog'
      });
      return this.$confirm(`<div class="tips_dialog_content">
          <i class=${iconType} style="color:${iconColor}"></i>
          <p>
            <span>${msg}</span>
            <span>${content}</span>
						<span>${tis}</span>
          </p>
        </div> `, title, settings, msg, content, tis ,iconType, iconColor );
    };
  }
}

export default TipsNewDialog



// WEBPACK FOOTER //
// ./src/components/dialog/tipsNewDialog/index.js